import { Component } from '@angular/core';
import { MenuComponent } from '../menu.component';

@Component({
    selector: 'ez-public-menu',
    template: require('./public-menu.component.html'),
    styles: [require('./public-menu.component.less')]
})
export class PublicMenuComponent extends MenuComponent {
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./src/app/components/public/public-menu.component.ts